import { render, staticRenderFns } from "./PanelContactInformations.vue?vue&type=template&id=bfe4fcb6&scoped=true"
import script from "./PanelContactInformations.vue?vue&type=script&lang=js"
export * from "./PanelContactInformations.vue?vue&type=script&lang=js"
import style0 from "./PanelContactInformations.vue?vue&type=style&index=0&id=bfe4fcb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe4fcb6",
  null
  
)

export default component.exports